import React, { useEffect, useState } from "react";
import { api, formatMXN } from "../../lib/api";

const Card = ({ label, value, accent = false }) => (
  <div className={`p-6 ${accent ? "bg-[#A94438] text-[#F9F6F0]" : "bg-white border border-[#E8E3DA]"}`}>
    <p className={`text-[10px] uppercase tracking-[0.3em] ${accent ? "text-[#F9F6F0]/70" : "text-[#5B605E]"}`}>{label}</p>
    <p className="font-serif text-4xl tracking-tighter mt-2">{value}</p>
  </div>
);

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then(({ data }) => setStats(data)); }, []);
  if (!stats) return <p>Cargando…</p>;

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-5xl tracking-tighter">Panel</h1>
      <p className="text-[#5B605E] mt-1">Resumen general de Tienda Bonita.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 mt-8">
        <Card label="Ingresos" value={formatMXN(stats.totals.revenue)} accent />
        <Card label="Pedidos" value={stats.totals.orders} />
        <Card label="Pagados" value={stats.totals.paid_orders} />
        <Card label="Productos" value={stats.totals.products} />
        <Card label="Clientes" value={stats.totals.users} />
        <Card label="Suscriptores" value={stats.totals.subscribers} />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10">
        <div className="bg-white border border-[#E8E3DA] p-6">
          <h2 className="font-serif text-2xl tracking-tighter mb-4">Ventas por categoría</h2>
          {stats.by_category.length === 0 ? (
            <p className="text-sm text-[#5B605E]">Aún sin ventas.</p>
          ) : stats.by_category.map((c) => (
            <div key={c.category} className="flex items-center justify-between py-2 border-b border-[#E8E3DA] last:border-0 text-sm">
              <span className="capitalize">{c.category}</span>
              <span className="font-medium">{formatMXN(c.revenue)}</span>
              <span className="text-xs text-[#5B605E]">{c.qty} uds</span>
            </div>
          ))}
        </div>
        <div className="bg-white border border-[#E8E3DA] p-6">
          <h2 className="font-serif text-2xl tracking-tighter mb-4">Pedidos recientes</h2>
          {stats.recent_orders.length === 0 ? (
            <p className="text-sm text-[#5B605E]">Sin actividad reciente.</p>
          ) : stats.recent_orders.map((o, i) => (
            <div key={i} className="flex items-center justify-between py-2 text-sm border-b border-[#E8E3DA] last:border-0">
              <span>{new Date(o.created_at).toLocaleDateString("es-MX")}</span>
              <span className="font-medium">{formatMXN(o.total)}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
